import { useNavigate } from 'react-router-dom';
import { CheckCheck, Trash2, Bell } from 'lucide-react';
import styles from '../../css/notifications/NotificationItem.module.css';

function relativeDate(iso) {
  const diff = Date.now() - new Date(iso);
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'только что';
  if (mins < 60) return `${mins} мин. назад`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} ч. назад`;
  const days = Math.floor(hours / 24);
  if (days === 1) return 'вчера';
  return `${days} дн. назад`;
}

const NotificationItem = ({ notification, onMarkRead, onDelete }) => {
  const navigate = useNavigate();
  const { id, title, body, link, payload, is_read, created_at } = notification;
  const posterURL = payload?.poster_url;

  const handleClick = (e) => {
    if (e.target.closest('[data-action]')) return;
    if (link) navigate(link);
  };

  return (
    <div
      className={`${styles.item} ${!is_read ? styles.unread : ''}`}
      onClick={handleClick}
      role={link ? 'button' : undefined}
      style={link ? { cursor: 'pointer' } : undefined}
    >
      {/* Колонка 1 — постер */}
      <div className={styles.poster}>
        {posterURL ? (
          <img
            src={`https://doramahype.ru/uploads/posters/${posterURL}`}
            alt={title}
            className={styles.posterImg}
          />
        ) : (
          <div className={styles.posterPlaceholder}>
            <Bell size={20} strokeWidth={1.5} />
          </div>
        )}
      </div>

      {/* Колонка 2 — текст */}
      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        <p className={styles.meta}>
          {body && <span className={styles.body}>{body}</span>}
          {body && <span className={styles.dot}>·</span>}
          <span className={styles.date}>{relativeDate(created_at)}</span>
        </p>
      </div>

      {/* Колонка 3 — кнопки */}
      <div className={styles.actions} data-action>
        {!is_read && (
          <button
            className={styles.actionBtn}
            title="Отметить прочитанным"
            data-action
            onClick={(e) => { e.stopPropagation(); onMarkRead(id); }}
          >
            <CheckCheck size={16} strokeWidth={2} />
          </button>
        )}
        <button
          className={`${styles.actionBtn} ${styles.deleteBtn}`}
          title="Удалить"
          data-action
          onClick={(e) => { e.stopPropagation(); onDelete(id); }}
        >
          <Trash2 size={16} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
};

export default NotificationItem;
